<template>
  <div class="wrapper">
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.1416 0.00733753C2.31661 0.00252537 2.50965 0.000501588 2.7168 0.000501588H7.3877C7.71877 0.000500998 8.01342 -0.000375316 8.25684 0.0200328C8.50978 0.0412743 8.77372 0.0898193 9.03027 0.224134C9.4041 0.419935 9.70468 0.73001 9.8916 1.10695C10.0322 1.39071 10.074 1.68546 10.0908 1.96925C10.1151 2.38242 9.7999 2.73754 9.38672 2.76222C8.9734 2.78676 8.61856 2.47136 8.59375 2.05812C8.58128 1.84825 8.55605 1.78961 8.54785 1.77296C8.49915 1.67491 8.42336 1.5986 8.33496 1.55226C8.32864 1.54895 8.28864 1.52833 8.13184 1.51515C7.96561 1.50119 7.74431 1.5005 7.3877 1.5005H5.75879C6.17107 1.87556 6.41602 2.41558 6.41602 2.99171V11.3687H7.3877C7.74428 11.3687 7.96561 11.368 8.13184 11.354C8.28713 11.341 8.32804 11.3205 8.33496 11.3169C8.42334 11.2706 8.49913 11.1942 8.54785 11.0962C8.55584 11.0801 8.58117 11.0222 8.59375 10.811C8.61845 10.3977 8.97332 10.0824 9.38672 10.1069C9.79997 10.1316 10.1152 10.4867 10.0908 10.8999C10.0739 11.1837 10.0322 11.4785 9.8916 11.7622C9.70464 12.1391 9.40411 12.4503 9.03027 12.646C8.77386 12.7801 8.50963 12.8279 8.25684 12.8491C8.01343 12.8695 7.71876 12.8687 7.3877 12.8687H5.875C5.35033 13.4309 4.5177 13.6829 3.70898 13.3589L1.25098 12.3735C0.4897 12.0684 0.000190171 11.3241 0 10.5093V2.00636C0 1.68016 0.0782144 1.37556 0.211914 1.10695C0.213339 1.10407 0.215328 1.10101 0.216797 1.09816C0.234319 1.06341 0.253051 1.02911 0.272461 0.995619C0.28776 0.96908 0.30483 0.943244 0.321289 0.917494C0.343619 0.882766 0.366309 0.848112 0.390625 0.814955C0.423241 0.770231 0.458009 0.726876 0.494141 0.685072C0.505577 0.671915 0.517536 0.658849 0.529297 0.646009C0.622253 0.544038 0.725388 0.451492 0.837891 0.370619C0.853961 0.359055 0.870318 0.34752 0.886719 0.336439C0.927204 0.309159 0.969107 0.283605 1.01172 0.259291C1.34668 0.0672826 1.7368 -0.0282642 2.1416 0.00733753ZM1.97168 1.51515C1.8717 1.52356 1.81938 1.53532 1.79297 1.54347C1.76345 1.55643 1.73461 1.57158 1.70801 1.59035C1.6851 1.6072 1.66262 1.6259 1.64258 1.64699C1.62811 1.66175 1.61617 1.67906 1.60352 1.69581C1.58591 1.71969 1.56933 1.74544 1.55566 1.77296C1.55168 1.78089 1.54617 1.78866 1.54199 1.7964C1.5156 1.85833 1.5 1.9292 1.5 2.00636V10.5093C1.50019 10.7255 1.62947 10.9091 1.80859 10.981L4.2666 11.9663C4.55872 12.0833 4.91572 11.8706 4.91602 11.4946V2.99171C4.91602 2.77537 4.78664 2.59196 4.60742 2.52003L2.14941 1.53468C2.11951 1.5227 2.08843 1.51651 2.05762 1.51124C2.02747 1.51286 1.9986 1.51289 1.97168 1.51515Z" fill="white"/>
      <path d="M10.1748 3.91066C10.5222 3.6854 10.9864 3.78422 11.2119 4.13136L12.3271 5.85109C12.5568 6.20539 12.5569 6.66384 12.3271 7.01808L11.2119 8.73781C10.9864 9.08478 10.5221 9.18363 10.1748 8.95851C9.82744 8.73315 9.72896 8.26886 9.9541 7.9214L10.4316 7.18507H8.73926C8.32532 7.18507 7.98971 6.8489 7.98926 6.43507C7.98926 6.02086 8.32504 5.68507 8.73926 5.68507H10.4326L9.9541 4.94777C9.72879 4.60035 9.82751 4.13612 10.1748 3.91066Z" fill="white"/>
      </svg>
  </div>
</template>

<script>

export default {
  name: 'ExitIcon'
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  cursor: pointer;

  path {
      transition: 0.5s;
    }

    @media(any-hover: hover) {
      &:hover {
        path {
          fill: #E6E6E6;
          transition: 0.5s;
        }
      }
    }

  &:active {
    path{
      fill: #E6E6E6;
      transition: 0.3s ease;
    }
  }
}

// svg {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 18px;
//   height: 20px;
//   transition: 0.5s ease;
// }
</style>
